import { AHIcon, Box, ListItem } from "arkh";
import React from "react";
import { WACategoryType } from "./Categories/WACategoryType";

export function WACategoryListItem<T>(props: {
  isFirst?: boolean;
  isLast?: boolean;
  category: WACategoryType<T>;
  selected: boolean;
  onPressIn?(): void;
  onPress?(): void;
  chevron?: boolean;
}) {
  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      isSelected={props.selected}
      left={
        <Box
          style={{
            width: 30,
            height: 30,
            backgroundColor: props.category.color,
            alignItems: "center",
            justifyContent: "center",
          }}
          cornerRadius="medium"
        >
          <AHIcon type={props.category.icon} color="surface" size="small" />
        </Box>
      }
      right={props.chevron ? <ListItem.NavArrow /> : null}
    >
      <ListItem.Title>{props.category.title}</ListItem.Title>
    </ListItem>
  );
}
